export function Step5Icon4() {
    return (
        <svg width="144" height="47" viewBox="0 0 144 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.5414 14.3047H18.5312C16.2008 14.3047 14.3049 16.1986 14.3049 18.5267V20.9572H31.7678V18.5267C31.7678 16.1988 29.8718 14.3047 27.5414 14.3047Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M38.1119 1H8.79212C5.87104 1 3.49463 3.41209 3.49463 6.37692V20.9575C4.07033 20.817 4.67012 20.7405 5.28769 20.7405H11.6593V18.2759C11.6593 14.1924 14.9325 10.8702 18.9558 10.8702H27.9484C31.9717 10.8702 35.2448 14.1924 35.2448 18.2759V20.7405H41.6165C42.2341 20.7405 42.834 20.8169 43.4097 20.9575V6.37692C43.4095 3.41209 41.033 1 38.1119 1Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M41.3754 24.2832H33.5696H13.3348H5.52903C3.03166 24.2831 1 26.3977 1 28.9969V38.4198H45.9044V28.9969C45.9044 26.3977 43.8727 24.2832 41.3754 24.2832Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M3.49463 40.9141V44.4439C3.49463 45.2499 4.23923 45.9034 5.15775 45.9034C6.07628 45.9034 6.82088 45.25 6.82088 44.4439V40.9141H3.49463Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M40.0835 40.9141V44.4439C40.0835 45.2499 40.8281 45.9034 41.7466 45.9034C42.6651 45.9034 43.4097 45.25 43.4097 44.4439V40.9141H40.0835Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M76.8056 14.3047H67.7953C65.465 14.3047 63.5691 16.1986 63.5691 18.5267V20.9572H81.0319V18.5267C81.0319 16.1988 79.136 14.3047 76.8056 14.3047Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M87.3761 1H58.0563C55.1352 1 52.7588 3.41209 52.7588 6.37692V20.9575C53.3345 20.817 53.9343 20.7405 54.5518 20.7405H60.9235V18.2759C60.9235 14.1924 64.1967 10.8702 68.2199 10.8702H77.2126C81.2358 10.8702 84.509 14.1924 84.509 18.2759V20.7405H90.8807C91.4982 20.7405 92.0982 20.8169 92.6738 20.9575V6.37692C92.6736 3.41209 90.2971 1 87.3761 1Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M90.6395 24.2832H82.8338H62.5989H54.7932C52.2958 24.2831 50.2642 26.3977 50.2642 28.9969V38.4198H95.1686V28.9969C95.1686 26.3977 93.1369 24.2832 90.6395 24.2832Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M52.7588 40.9141V44.4439C52.7588 45.2499 53.5034 45.9034 54.4219 45.9034C55.3404 45.9034 56.085 45.25 56.085 44.4439V40.9141H52.7588Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M89.3477 40.9141V44.4439C89.3477 45.2499 90.0923 45.9034 91.0108 45.9034C91.9293 45.9034 92.6739 45.25 92.6739 44.4439V40.9141H89.3477Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M124.371 14.3047H115.361C113.03 14.3047 111.135 16.1986 111.135 18.5267V20.9572H128.597V18.5267C128.597 16.1988 126.701 14.3047 124.371 14.3047Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M134.941 1H105.622C102.701 1 100.324 3.41209 100.324 6.37692V20.9575C100.9 20.817 101.5 20.7405 102.117 20.7405H108.489V18.2759C108.489 14.1924 111.762 10.8702 115.785 10.8702H124.778C128.801 10.8702 132.074 14.1924 132.074 18.2759V20.7405H138.446C139.064 20.7405 139.664 20.8169 140.239 20.9575V6.37692C140.239 3.41209 137.863 1 134.941 1Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M138.205 24.2832H130.399H110.164H102.359C99.8613 24.2831 97.8296 26.3977 97.8296 28.9969V38.4198H142.734V28.9969C142.734 26.3977 140.702 24.2832 138.205 24.2832Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M100.324 40.9141V44.4439C100.324 45.2499 101.069 45.9034 101.987 45.9034C102.906 45.9034 103.65 45.25 103.65 44.4439V40.9141H100.324Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path
                d="M136.913 40.9141V44.4439C136.913 45.2499 137.658 45.9034 138.576 45.9034C139.495 45.9034 140.239 45.25 140.239 44.4439V40.9141H136.913Z"
                stroke="#9800F5"
                strokeWidth="2"
            />
            <path d="M135.791 40.9141V43.8556C135.791 44.5273 136.349 45.0719 137.038 45.0719C137.727 45.0719 138.285 44.5273 138.285 43.8556V40.9141H135.791Z" fill="#9B4DF6" />
        </svg>
    )
}
